"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typeChecks_1 = require("./typeChecks");
/**
 * Gets the value at path of object. If the resolved value is undefined, the defaultValue is returned in its place.
 *
 * @param {Object} object
 * @param {string[] | string} path
 * @param {*} defaultValue
 * @returns {*}
 */
function get(object, path, defaultValue) {
    if (path === undefined) {
        return defaultValue;
    }
    path = Array.isArray(path) ? path : path.split('.');
    var result = object;
    if (!typeChecks_1.isNullOrUndefined(result)) {
        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
            var pathValue = path_1[_i];
            var parts = pathValue.split('[');
            for (var _a = 0, parts_1 = parts; _a < parts_1.length; _a++) {
                var part = parts_1[_a];
                if (typeChecks_1.isNullOrUndefined(result)) {
                    break;
                }
                var workingPart = part.replace(']', '');
                result = result[workingPart];
            }
            if (typeChecks_1.isNullOrUndefined(result)) {
                break;
            }
        }
    }
    return result !== undefined ? result : defaultValue;
}
exports.get = get;
//# sourceMappingURL=get.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/utils/get.js
// module id = 55
// module chunks = 1